import styled, { css } from 'styled-components';

import NavigationLink from 'ggApp/shared/common/NavigationLink';

export const Link = styled(NavigationLink)`
    ${({theme}) => css(theme.typography.SmallCapsHeadline)};
    &:not(:last-child) {
        margin-right: 24px;
    }
    ${({ theme }) => theme.superQuery.all.and.maxWidth.mobileMax.css`
        margin: 0 0 0 auto;
    `};
`;
